import { IconButton, InputAdornment, TextField } from '@mui/material'
import React, { useState } from 'react'
import GenerateIcon from '../GenerateIcon'

export interface ITextFieldElement {
    id?: string,
    type?: string,
    value?: any
    label?: string,
    fullWidth?: boolean,
    handleOnChange: (value: any) => void
}

export default function TextFieldElement(props: ITextFieldElement) {

    const { id, type, label, value, fullWidth, handleOnChange } = props

    const [fieldType, setFieldType] = useState<string>(type ? type : "text")

    let inputProps = {}

    if (type === "password"){
        inputProps = {
            endAdornment: <InputAdornment position="end"><IconButton onMouseUp={() => setFieldType("password")} onMouseDown={() => setFieldType("text")}><GenerateIcon icon={fieldType === "password" ? "show" : "hide"} /></IconButton></InputAdornment>
        }
    }

    return <TextField id={id} type={fieldType} label={label} variant="outlined" fullWidth={fullWidth} value={value} onChange={(e) => handleOnChange(e.target.value)} InputProps={inputProps} />
}